app.fonts = function() {
    try{
        Typekit.load({ async: true });
    }
    catch(e){
        console.log('error loading fonts:' + e);
    }
}